import { useNavigate } from "react-router-dom";
import ErrorFullScreenMessage from "../../components/fullScreenMessage/ErrorFullScreenMessage";
import Loader from "../../components/loader/Loader";
import useUser from "../../hooks/useUser";
import { useIsMobile } from "../../utils/Functions";
import AdminDesktopHomePage from "./components/AdminDesktopHomePage";
import MasterHomePage from "./components/masterHomePage/MasterHomePage";
import OtherHomePageViews from "./components/OtherHomePageViews";
import UserDesktopHomePage from "./components/UserDesktopHomePage";
import UserMobileHomePage from "./components/UserMobileHomePage";
import { AI_ASSISTANT } from "../../enums/UrlPaths";
import React from "react";

export const STACIONAR_EMAIL = "betida4131@devlug.com";

export default function HomePage() {
  const { isLoading: userLoading, roles, error, profile, currentClinic } = useUser();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  // Without this check a disabled clinic would bounce between here and the AI page
  const redirectToAi =
    profile.email == STACIONAR_EMAIL && currentClinic.aiAssistantEnabled;

  React.useEffect(() => {
    if (redirectToAi) {
      navigate(AI_ASSISTANT);
    }
  },[])

  switch (true) {
    case userLoading:
      return <Loader />;

    case !!error:
      return <ErrorFullScreenMessage />;
    
    case redirectToAi:
      navigate(AI_ASSISTANT);
      return null;

    case roles.user && isMobile:
      return <UserMobileHomePage />;

    case roles.user && !isMobile:
      return <UserDesktopHomePage />;

    case roles.adminOrEmployee && !isMobile:
      return <AdminDesktopHomePage />;

    case roles.master:
      return <MasterHomePage />;

    default:
      return <OtherHomePageViews />;
  }
}

